import { render } from "./SingleAnime.vue?vue&type=template&id=89c90330&scoped=true"
import script from "./SingleAnime.vue?vue&type=script&lang=js"
export * from "./SingleAnime.vue?vue&type=script&lang=js"

import "./SingleAnime.vue?vue&type=style&index=0&id=89c90330&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89c90330"]])

export default __exports__